<script>
	import { css } from '../../node_modules/@emotion/css/dist/emotion-css.umd.min.js'

	export let completionCriteria = []
	export let error

	let completionProgress = 0, nextIncompletedTask

	const percentage = val => Math.round(val*100) + '%'

	$: {
		const total = completionCriteria.length
		const completed = completionCriteria.filter(x => x.completed).length
		if (!total)
			completionProgress = 1
		else {
			completionProgress = completed/total
			const { description } = completionCriteria.find(x => !x.completed) || {}
			nextIncompletedTask = description || ''
		}
	}

	const mainClass = css(`
		& .uxmagic-status {
			display: flex;
			align-items: center;
		}

		& .uxmagic-status-text {
			line-height: 30px;
		}

		& .uxmagic-title {
			font-weight: bold;
		}

		& .uxmagic-perc {
			font-family: 'Courier New', monospace;
			font-weight: bold;
			font-size: 30px;
			color: var(--primary);
			flex-grow: 1;
			display: flex;
			justify-content: flex-end;

			&.uxmagic-perc-100 {
				color: var(--success);
			}
		}

		& .uxmagic-uncompleted-inst {
		}

		& .uxmagic-inst {
			opacity: 0.6;
			line-height: 22px;
			font-style: italic;
			height: 90px;
			overflow: scroll;
		}

		& .uxmagic-congrats {
			padding-top: 20px;
			line-height: 26px;
			color: var(--success);

			&.uxmagic-oops {
				color: var(--danger);
			}

			& .uxmagic-congrats-title {
				font-size: 20px;
				font-weight: bold;
				margin-bottom: 10px;
			}
		}
	`)

</script>

<div class={mainClass}>
	{#if completionProgress < 1 && nextIncompletedTask}
	<div class="uxmagic-status">
		<div class="uxmagic-title uxmagic-status-text">Task completion progress:</div>
		<div class={`uxmagic-perc${completionProgress == 1 ? ' uxmagic-perc-100' : ''}`}>{percentage(completionProgress)}</div>
	</div>
	<div class="uxmagic-uncompleted-inst">	
		<div class="uxmagic-title uxmagic-status-text">Next uncompleted instruction:</div>
		<div class="uxmagic-inst uxmagic-status-text">{nextIncompletedTask}</div>
	</div>
	{:else}
	<div class={`uxmagic-congrats ${error ? 'uxmagic-oops' : ''}`}>
		<div class="uxmagic-congrats-title">{error ? 'Oops, something went wrong 🤯' : 'Congratulation 🎉!'}</div>
		<div>{@html error || 'You have successfully completed all the instructions. To collect your reward, click the <b>Claim reward</b> button below.'}</div>
	</div>
	{/if}
</div>